export default __webpack_public_path__ + "static/media/montagne.50ad3155.png";